import Mousetrap from "mousetrap";
import prettier from "../prettier";
import Tabs from "../tabs";

/**
 * Main.bindCommands enables ixcanul's basic keyboard commands
 **/
export default () => {
  const body = document.body;

  Mousetrap(body).bind(
    ["ctrl+s", "command+s"],
    function() {
      if (typeof window.selectedNode === "undefined") return false;
      if (window.selectedNodeAvailable === true) {
        let node = selectedNode;
        let title = node.title;
        let session = aceSessions["session_" + node.key];
        const extension = title.split(".").last();
        const beautify = prettier(extension, session, node.data.path);
        if (beautify !== true) {
          const error = beautify
            .split("\n")
            .filter(l => !l.trim().startsWith("at"))
            .join("\n");
          $(`#formating_error`)
            .parent()
            .remove();
          CodeEditor.UI.notif.error({
            id: "formating_error",
            message: `${selectedNode.title} can't be saved due to the following error: <pre style="color:#fff;white-space: pre;max-width: 700px;">${error}</pre>`,
            timeout: 10000000000,
            position: "bottomRight"
          });
          return false;
        }
        $(`#formating_error`)
          .parent()
          .remove();
        let session_content = session.getValue();
        CodeEditor.Main.saveFile(node, title, session_content);
      } else {
        CodeEditor.UI.notif.error({
          message: selectedNode.title + "can't be saved at the moment!, Ixcanul is busy",
          timeout: 1000,
          position: "bottomRight"
        });
        console.log("save action blocked!");
      }
      return false;
    },
    "keypress"
  );

  // Mousetrap(body).bind(['ctrl+e', 'command+e'], function(e) {
  //   CodeEditor.SearchFile.toggle();
  //   return false;
  // });
  Mousetrap(body).bind(["ctrl+p", "command+p"], function() {
    CodeEditor.ContextMenu.fileSearch();
    return false;
  });
  Mousetrap(body).bind(["ctrl+0", "command+0"], function() {
    if ($(".ace_editor").length > 0) {
      editor.setOption("fontSize", "15px");
    }
    return false;
  });

  Mousetrap(body).bind(
    ["alt+w", "command+w"],
    function(e) {
      e.preventDefault();
      if ($(".tingle-modal").length) {
        return false;
      }
      let activeTab = Tabs.getActiveTab();
      if (activeTab.element[0].isConnected && Panes.codePaneChildren().length > 0) {
        Tabs.close(activeTab.config.id);
      }
      return false;
    },
    "keypress"
  );
  Mousetrap(body).bind(
    ["ctrl+shift+f"],
    () => {
      let node = tree.getActiveNode();
      CodeEditor.SearchFolder.toggleView();
      if (!node?.folder) node = node?.parent;
      CodeEditor.SearchFolder.attachNode(node);
      return false;
    },
    "keyup"
  );
  const fontSizeScrollHandler = function(event) {
    if (!event.metaKey) return;
    const aceEditor = document.querySelector(".ace_editor");
    if (aceEditor) {
      const currentFZ = editor.getOption("fontSize");
      const regExp = new RegExp(/(\d*|\d*\.\d*)px/g);
      const currentFZNumber = parseFloat(editor.getOption("fontSize").match(regExp)[0]);
      event.preventDefault();
      if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
        const newFZ = currentFZNumber + 0.5;
        editor.setOption("fontSize", currentFZ.replace(regExp, newFZ + "px"));
        return;
      }
      let newFZ = currentFZNumber - 0.5;
      newFZ = newFZ < 10 ? 10 : newFZ;
      editor.setOption("fontSize", currentFZ.replace(regExp, newFZ + "px"));
    }
    return;
  };
  document.addEventListener("keydown", ev => {
    if (ev.which === 91 || ev.which === 18) {
      $(window).on("mousewheel DOMMouseScroll", fontSizeScrollHandler);
    }
  });
  document.addEventListener("keyup", e => {
    if (e.which === 91 || e.which === 18) {
      $(window).off("mousewheel DOMMouseScroll", fontSizeScrollHandler);
    }
  });
};
